import React from 'react';

import { useCurrentUserEmployer } from '../employer';
import { useEmployerRevenueShare } from '../employer/useEmployerRevenueShare';
import { useCurrentUserPeo } from '../peo';
import { usePeoRevenueShare } from '../peo/usePeoRevenueShare';
import {
  useCurrentUserPeoPayrollProvider,
  usePeoPayrollProviderRevenueShare,
} from '../peoPayrollProvider';

export const useCurrentUserCompanyRevenueShare = () => {
  const { employerId } = useCurrentUserEmployer();
  const { employerBilling, loading: employerBillingLoading } = useEmployerRevenueShare(employerId);

  const { peoId } = useCurrentUserPeo();
  const { peoBilling, loading: peoBillingLoading } = usePeoRevenueShare(peoId);

  const { peoPayrollProviderId } = useCurrentUserPeoPayrollProvider();
  const { peoPayrollProviderBilling, loading: peoPayrollProviderBillingLoading } =
    usePeoPayrollProviderRevenueShare(peoPayrollProviderId);

  const revenueShareSetting = React.useMemo(() => {
    return (
      employerBilling?.revenueShareSetting ||
      peoBilling?.revenueShareSetting ||
      peoPayrollProviderBilling?.revenueShareSetting ||
      null
    );
  }, [
    employerBilling?.revenueShareSetting,
    peoBilling?.revenueShareSetting,
    peoPayrollProviderBilling?.revenueShareSetting,
  ]);

  const revenueShareReportEnabled = React.useMemo(() => {
    return (
      employerBilling?.revenueShareReportEnabled ||
      peoBilling?.revenueShareReportEnabled ||
      peoPayrollProviderBilling?.revenueShareReportEnabled ||
      false
    );
  }, [
    employerBilling?.revenueShareReportEnabled,
    peoBilling?.revenueShareReportEnabled,
    peoPayrollProviderBilling?.revenueShareReportEnabled,
  ]);

  return {
    revenueShareSetting,
    revenueShareReportEnabled,
    loading: employerBillingLoading || peoBillingLoading || peoPayrollProviderBillingLoading,
  };
};
